import useAxiosService from './useAxiosService'
import { IResponse } from 'interfaces/services'
import { IPatient } from 'pages/patientReceive/interfaces'

export const usePatientService = () => {
  const { post } = useAxiosService()

  const requestAddProfile = async (
    patient_id: string | number
  ): Promise<IResponse<{ request_id: string }>> => {
    const response: any = await post('/clinic/patient/add', { patient_id })
    return response as IResponse<{ request_id: string }>
  }

  const requestOTPAddPatient = async (
    request_id: string | number
  ): Promise<IResponse<Array<IPatient>>> => {
    const response: any = await post('/clinic/patient/add/request-otp', {
      request_id
    })
    return response as IResponse<Array<IPatient>>
  }

  const verifyOTPAddPatient = async (
    request_id: string | number,
    otp: string
  ): Promise<IResponse<Array<IPatient>>> => {
    const response: any = await post('/clinic/patient/add/verify-otp', {
      request_id,
      otp
    })
    return response as IResponse<Array<IPatient>>
  }
  return { requestAddProfile, requestOTPAddPatient, verifyOTPAddPatient }
}
